import { observeElement, getWidget } from '@uvocore-front/utils';
import './Calculator.scss';

/**
 *  Calculator
 */
const isPageConfig =
  window.pageConfig &&
  Object.keys(window.pageConfig).length > 0 &&
  window.pageConfig.constructor === Object;

// Calculator Observer
if (document.querySelector('[data-calc-mini]')) {
  observeElement({
    element: '[data-calc-mini]',
    marginValue: 400,
    callback: () => {
      getWidget({
        widgetLink: '/assets/js/calc.js',
        loader: false,
        fn: () => {
          const pagePaperType =
            isPageConfig &&
            window.pageConfig.calculator !== undefined &&
            window.pageConfig.calculator.hasOwnProperty('pagePaperType') /* eslint-disable-line */
              ? window.pageConfig.calculator.pagePaperType
              : undefined;

          const calcOptions = {
            ID: '14',
            calculatorType: 'DefaultCalculator',
            format: 'json',
          };

          if (pagePaperType !== undefined) {
            calcOptions.options.deafault.paperTypesDefault = pagePaperType;
          }

          if (window.Calc) {
            const calc = new Calc(calcOptions); /* eslint-disable-line */
          }
        },
      });
    },
  });
}
